module.exports = __webpack_public_path__ + "img/zxyfw-3.7f3725b4.jpg";